export const UpsellTrackingEvents = {
  sheetDismissed: 'Upsell Sheet Dismissed',
  sheetOpened: 'Upsell Sheet Opened',
  upgradeClicked: 'Upsell Sheet Upgrade Clicked',
} as const

/**
 * Identifies which gated control opened the upsell sheet. Threaded through
 * `openUpsellSheet` so the open/dismiss/upgrade events can be attributed to the
 * pro button that triggered them.
 */
export const UpsellSource = {
  giftCardsPage: 'gift_cards_page',
  homeDashboardBanner: 'home_dashboard_banner',
  marketingAutomatedCampaign: 'marketing_automated_campaign',
  marketingSmsCreate: 'marketing_sms_create',
  navSidebar: 'nav_sidebar',
  printShopGiftCards: 'print_shop_gift_cards',
  settingsBrandDetailsGiftCards: 'settings_brand_details_gift_cards',
  settingsMarketingSms: 'settings_marketing_sms',
  settingsMobile: 'settings_mobile',
  websiteBuilderReservationEmbed: 'website_builder_reservation_embed',
  websiteBuilderReservationEmbedAdd: 'website_builder_reservation_embed_add',
  websiteCareers: 'website_careers',
  websiteGiftCards: 'website_gift_cards',
  websiteReservations: 'website_reservations',
} as const

export type UpsellSourceValue = (typeof UpsellSource)[keyof typeof UpsellSource]
